import styled from 'styled-components';

export const StyledPlaySimpleBalance = styled.div`
    display: inline-flex;
    align-items: center;
    margin: 0 4px;
    font-weight: ${({ playerName }: any) => (playerName ? 'inherit' : '600')};
    min-height: 25px;

    .playSimple-balance {
        position: relative;

        &__img {
            position: absolute;
            height: 24px;
            aspect-ratio: 1/1;
            margin-right: 0.5em;
            background-color: transparent;
        }

        &__amount {
            padding: 0 10px 0 30px;
            background: rgba(0, 0, 0, 0.6);
            border-radius: 16px;
            color: #ffffff;
        }
    }
` as any;
